/**
 * XP para atingir o nível n (Baseline A.1: 8·n^1.4, arredondado) — literal (Math.pow banido na sim).
 * Índice 0 inutilizado; níveis 1..60. Gerada 1× fora da sim; NUNCA regenerar sem errata.
 */
const XP: readonly number[] = [0, 8, 21, 37, 56, 76, 98, 122, 147, 173, 201, 230, 259, 290, 322, 355, 388, 422, 458, 494, 530, 568, 606, 645, 685, 725, 766, 807, 849, 892, 936, 979, 1024, 1069, 1115, 1161, 1208, 1255, 1303, 1351, 1400, 1449, 1498, 1549, 1599, 1650, 1702, 1754, 1806, 1859, 1913, 1966, 2021, 2075, 2130, 2186, 2242, 2298, 2354, 2411, 2469] as const;

export const MAX_LEVEL = 60;

/** XP necessário para SUBIR ao nível n (n≥1) */
export function xpForLevel(n: number): number {
  if (n < 1) return 0;
  if (n > MAX_LEVEL) return Number.MAX_SAFE_INTEGER;
  return XP[n] ?? Number.MAX_SAFE_INTEGER;
}
